/*
  ML017 - size selector with the price inside every option (A/B variation).
  Markup: snippets/size-selector-ml017.liquid.

  Every size is a separate product, so picking one is a full page load. Two things make that
  feel less abrupt:

    1. the clicked option shows a pending state at once and further clicks are ignored, so
       nobody clicks twice while the next product loads;
    2. the selector's viewport offset is remembered, and the next product page scrolls back so
       the selector sits in the same place instead of the page starting at the top.

  Modified clicks (new tab / window) keep the browser's behaviour and leave no pending state.
*/

(function () {
  if (customElements.get('ml017-size-selector')) {
    return;
  }

  var STORAGE_KEY = 'ml017-size-scroll';
  var MAX_AGE = 15000;

  function readSaved() {
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (error) {
      return null;
    }
  }

  function writeSaved(value) {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(value));
    } catch (error) {
      // Storage unavailable (private mode, quota): the page simply loads at the top.
    }
  }

  function clearSaved() {
    try {
      sessionStorage.removeItem(STORAGE_KEY);
    } catch (error) {
      // Nothing to clean up.
    }
  }

  class Ml017SizeSelector extends HTMLElement {
    constructor() {
      super();
      this.onClick = this.onClick.bind(this);
      this.onPageShow = this.onPageShow.bind(this);
    }

    connectedCallback() {
      this.addEventListener('click', this.onClick);
      window.addEventListener('pageshow', this.onPageShow);
      this.restoreScroll();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      window.removeEventListener('pageshow', this.onPageShow);
    }

    onClick(event) {
      var option = event.target.closest('a.ml017-size__option');

      if (!option || !this.contains(option)) {
        return;
      }

      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
        return;
      }

      if (option.hasAttribute('aria-current') || this.getAttribute('aria-busy') === 'true') {
        event.preventDefault();
        return;
      }

      this.setAttribute('aria-busy', 'true');
      option.classList.add('is-pending');

      writeSaved({
        path: new URL(option.href, window.location.href).pathname,
        top: this.getBoundingClientRect().top,
        t: Date.now()
      });
    }

    onPageShow(event) {
      // Restored from the back/forward cache: the navigation that set the pending state is over.
      if (!event.persisted) {
        return;
      }

      this.removeAttribute('aria-busy');
      this.querySelectorAll('.is-pending').forEach(function (option) {
        option.classList.remove('is-pending');
      });
    }

    restoreScroll() {
      var saved = readSaved();

      if (!saved) {
        return;
      }

      clearSaved();

      if (saved.path !== window.location.pathname || Date.now() - saved.t > MAX_AGE || typeof saved.top !== 'number') {
        return;
      }

      var self = this;
      var align = function () {
        var delta = self.getBoundingClientRect().top - saved.top;

        if (Math.abs(delta) > 1) {
          window.scrollTo({ top: window.scrollY + delta, behavior: 'instant' });
        }
      };

      align();

      // Media and fonts above the selector (the gallery on mobile) can still shift the layout.
      if (document.readyState !== 'complete') {
        window.addEventListener('load', align, { once: true });
      }
    }
  }

  customElements.define('ml017-size-selector', Ml017SizeSelector);
})();
